import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSession, onAuthStateChange, supabase } from '../lib/auth';

const AuthContext = createContext(null);

async function checkMfaRequired() {
  const { data } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
  return data?.nextLevel === 'aal2' && data?.currentLevel !== 'aal2';
}

export function AuthProvider({ children }) {
  const [session, setSession] = useState(undefined); // undefined = loading
  const [mfaRequired, setMfaRequired] = useState(false);

  useEffect(() => {
    getSession().then(async (s) => {
      setSession(s);
      if (s) setMfaRequired(await checkMfaRequired());
    });

    const unsubscribe = onAuthStateChange(async (s) => {
      setSession(s);
      if (s) {
        setMfaRequired(await checkMfaRequired());
      } else {
        setMfaRequired(false);
      }
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ session, isLoading: session === undefined, mfaRequired }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
